import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    actionButtons: {
        display: 'flex',
        gap: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '75px',
    },
    iconButton: {
        padding: 0,
        gridRow: 1,
        backgroundColor: 'black',
        color: 'white',
        width: '26px',
        height: '26px',
        borderRadius: '4px',
        '&:hover': {
            backgroundColor: '#95969B',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    iconButtonError: {
        padding: 0,
        gridRow: 1,
        backgroundColor: 'red',
        color: 'white',
        width: '26px',
        height: '26px',
        borderRadius: '4px',
        '&:hover': {
            backgroundColor: '#95969B',
        },
        '& .MuiSvgIcon-root': {
            fontSize: '16px',
        },
    },
    iconEdit: {
        backgroundColor: 'black',
    },
}));
